import React from 'react'

const End = () => {
  return (
    <div class="flex h-screen items-center justify-center">
  <p class="text-2xl text-center">You have successfully completed Experiment 1: DES Key Generation<br></br>
    You may go back to list of experiments and try Experiment 2 for understandind DES Plaintext Encryption</p>
</div>
  )
}

export default End